// @ts-nocheck
import React from "react";
import PropTypes from "prop-types";

function getId(url) {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);

    return match && match[2].length === 11 ? match[2] : null;
}

export default function EmbedYouTube({ styles, url }) {
    const embedUrl = `//www.youtube.com/embed/${getId(url)}`;
    return (
        <div className={styles.embedYoutube}>
            <iframe
                width={560}
                height={315}
                src={embedUrl}
                frameBorder={0}
                allow={"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"}
                allowFullScreen
                title={"YouTube video"}
            />
        </div>
    );
}

EmbedYouTube.propTypes = {
    styles: PropTypes.object,
    url: PropTypes.string,
};
